import url from '@/utils/url'
import { csv } from 'd3-fetch'
import { autoType } from 'd3-dsv'
import { slugToRegion } from '@/utils/helpers'

const stores = {
  fire: {},
  forestLoss: {},
  forestCover: {}
}

const unpackToStore = (dimension, location, data) => {
  stores[dimension][location] = data
  const countries = data.columns.slice(1)
  countries.forEach(c => {
    const countryData = data.map(d => ({ date: d.date, [c]: d[c] }))
    countryData['columns'] = ['data', c]
    stores[dimension][c] = countryData
  })
}
/**
 * @property {function} getKeyIndicators
 * @property {function} get
 * @property {function} fetch
 *
 */
export default {
  DIMENSION_FIRE: 'fire',
  DIMENSION_DEFORESTATION: 'forestLoss',
  DIMENSION_FORESTCOVER: 'forestCover',
  /**
   * @async
   * @function fetch
   * @description fetches the data for the given region and dimension, unpacks and stores it
   *
   * @param {String} dimension - the type of indicator to get
   * @param {String} slug - the unsanitised region or country
   * @returns {Array} an array containing the raw data returned
   */
  fetch: async (dimension, slug) => {
    const location = slugToRegion(slug)
    if (!stores[dimension][location]) {
      const data = await csv(url(dimension, location), autoType)
      unpackToStore(dimension, location, data)
    }
    return stores[dimension][location]
  },
  /**
   * @function get
   * @description gets the data from the store
   *
   * @param {String} dimension - the type of indicator to get
   * @param {String} slug - the unsanitised region or country
   * @returns {Array} an array containing the raw data returned
   */
  get: (dimension, location) => {
    // const location = slugToRegion(slug)
    return stores[dimension][location]
  },
  /**
   * @function getKeyIndicators
   * @description fetches a key indicator from the data
   *
   * @param {String} dimension - the type of indicator to get
   * @param {String} slug - the unsanitised region or country
   * @returns {Object} - returns a {year|date, value} object
   */
  // @toddo: Obsolete ??!?
  getKeyIndicators: (dimension, slug) => {
    const location = slugToRegion(slug)
    const baseData = stores[dimension][location]
    const countries = baseData.columns.slice(1)

    if (dimension === 'fire') {
      const latestFires = baseData.slice(-1)
      let numFires = 0
      countries.forEach(d => {
        numFires += latestFires[0][d]
      })
      return {
        date: latestFires[0].date,
        value: numFires
      }
    }
    if (dimension === 'deforestation') {
      return {
        year: Math.min(...baseData.map(d => d.date)),
        value: Math.round(baseData.reduce(reduceObj, 0))
      }
    }
    if (dimension === 'forestcover') {
      // const dates = (baseData.map(d => d.date))
      const latestYear = Math.max(...baseData.map(d => d.date))
      const forestCover = baseData.find(d => d.date === latestYear)
      const [, ...nums] = Object.values(forestCover)
      return {
        year: latestYear,
        value: Math.round(nums.reduce(reduceList, 0))
      }
    }
  }
}
// basic numeric reducer
const reduceList = (accumulator, currentValue) => accumulator + currentValue
// object reducer, ignores first prop as it is the date (hence [,..nums])
const reduceObj = (accumulator, currentValue) => {
  const [, ...nums] = Object.values(currentValue)
  return accumulator + nums.reduce(reduceList, 0)
}
